import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgZorroAntdModule } from '@public-page/ng-zorro-antd/ng-zorro-antd.module';
// @ngrx
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// paymash libs
import { ButtonModule } from '@paymash/ui-kit';
// child imports
import { CookiesNotAllowedPlaceholderComponent } from './components/';
import { CookiesPolicyModalComponent } from './components/';
import { CookiesAllowedDirective } from './directives/';
import { effects, reducers } from './store';

@NgModule({
  declarations: [CookiesNotAllowedPlaceholderComponent, CookiesPolicyModalComponent, CookiesAllowedDirective],
  imports: [
    CommonModule,
    StoreModule.forFeature('cookies-allowed', reducers),
    EffectsModule.forFeature([...effects]),
    TranslateModule,
    ButtonModule,
    NgZorroAntdModule,
  ],
  exports: [CookiesPolicyModalComponent, CookiesAllowedDirective],
})
export class AllowedCookiesModule {}
